import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";

interface mutateProps {
  id: string;
  module: string;
  communityId: string;
}

const mutateDeleteData = async ({ id, communityId, module}: mutateProps) => {
  return await axiosAuth.delete(`v1/${module}/community/${communityId}/${id}`);
};

const useDeleteDataMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteData,
    ...queryParams,
  });

export default useDeleteDataMutation;
